<template>
  <div class="player">
    <div class="map-sticky" v-if="player">
      <PlayerMapHeader :scale-to="player.scale" :active-country="player.country_iso_3" />
    </div>
    <div class="player_general_info" v-if="player">
      <div class="row">
        <div class="col-2 col-sm-2 col-md-3 col-lg-3 pl-0 pr-4">
          <div ref="hide_section" class="hide_section" v-if="player">
            <div class="side_navigation">

              <div class="profile_top d-none d-sm-none d-md-block" :class="{ active: showMiniProfile }">
                <div class="row align-items-center" v-if="player">
                  <div class="col-4 pr-0 pl-1">
                    <img :src="getPlayerImage(player.id)" alt="Profile image" class="card-img-side">
                  </div>
                  <div class="col-8 pl-3 pr-0 align-self-center">
                    <h6 class="mb-1 pt-3">{{ translateIsoCountry(player.country_iso_3) }}</h6>
                    <h5 class="mb-1">{{ player.title }}</h5>
                    <h4 class="mb-0 d-inline-flex position-relative">
                      {{ player.short_name }}
                      <span>
                        <b-btn
                          :active="showShareOptions"
                          @click="showShareOptions = !showShareOptions"
                          class="text-white d-inline-flex justify-content-center align-items-center profile_top__share-btn"
                          variant="link"
                          size="sm">
                          <fa icon="share-alt" />
                          <span class="sr-only">Share</span>
                        </b-btn>
                      </span>
                      <CustomSharingOptions :title="`${$t('social.player')} ${translateIsoCountry(player.country_iso_3)} ${player.title} ${player.short_name}`" v-if="showShareOptions" direction="row" />
                    </h4>
                    <h6 v-if="player.sub_title">
                      {{ player.sub_title }}
                    </h6>
                  </div>
                </div>
              </div>

              <ul class="nav ml-auto d-none d-sm-none d-md-block mb-5">
                <li ref="player-bio_item" :class="{'active': activeSection == 'player-bio_item'}">
                  <button @click="showSection(`player-bio`)">
                    <IconBio class="mr-1" />
                    <span class="d-sm-none d-md-inline-block">{{ $t('playerProfile.about') }}</span>
                  </button>
                </li>
                <li ref="pandora-reveals_item" :class="{'active': activeSection == 'pandora-reveals_item'}">
                  <button @click="showSection(`pandora-reveals`)" class="d-sm-flex align-items-center">
                    <IconPandora class="mr-1" />
                    <span class="d-sm-none d-md-inline-block">{{ $t('playerProfile.pandora') }}</span>
                  </button>
                </li>
                <li v-if="player.provider && providers.length > 0" ref="secrecy-brokers_item" :class="{'active': activeSection == 'secrecy-brokers_item'}" >
                  <button  class="d-sm-flex align-items-center" @click="showSection(`secrecy-brokers`)">
                    <IconSecrecy class="mr-1" />
                    <span class="d-sm-none d-md-inline-block">{{ $t('playerProfile.secrecy') }}</span>
                  </button>
                </li>
                <li v-if="player.linkurious || (player.extra_linkurious_links && player.extra_linkurious_links.length > 0)" ref="explore-data_item" :class="{'active': activeSection == 'explore-data_item'}">
                  <button  class="d-sm-flex align-items-center" @click="showSection(`explore-data`)">
                    <IconData class="mr-1" />
                    <span class="d-sm-none d-md-inline-block">{{ $t('playerProfile.data') }}</span>
                  </button>
                </li>
                <li v-if="player.documents.length > 0" ref="documents_item" :class="{'active': activeSection == 'documents_item'}" >
                  <button  class="d-sm-flex align-items-center" @click="showSection(`documents`)">
                    <IconDocumentText class="mr-1" />
                    <span class="d-sm-none d-md-inline-block">{{ $t('playerProfile.documents') }}</span>
                  </button>
                </li>
                <li v-if="player.articles.length > 0" ref="related-stories_item" :class="{'active': activeSection == 'related-stories_item'}">
                  <button  class="d-sm-flex align-items-center" @click="showSection(`related-stories`)">
                    <IconLink class="mr-1" :width="16" :height="16" />
                    <span class="d-sm-none d-md-inline-block">{{ $t('playerProfile.related') }}</span>
                  </button>
                </li>
              </ul>

              <ul class="nav ml-auto d-block d-sm-block d-md-none mb-5">
                <li ref="player-bio_item" :class="{'active': activeSection == 'player-bio_item'}">
                  <button @click="showSection(`player-bio`)" class="text-center">
                    <IconBio class="mr-1" :width="24" :height="24" />
                  </button>
                </li>
                <li ref="pandora-reveals_item" :class="{'active': activeSection == 'pandora-reveals_item'}">
                  <button @click="showSection(`pandora-reveals`)" class="text-center"><IconPandora class="mr-1" :width="24" :height="24" /></button></li>
                <li v-if="player.provider && providers.length > 0" ref="secrecy-brokers_item" :class="{'active': activeSection == 'secrecy-brokers_item'}" >
                  <button @click="showSection(`secrecy-brokers`)" class="text-center"><IconSecrecy class="mr-1" :width="24" :height="24" /></button></li>
                <li v-if="player.linkurious || (player.extra_linkurious_links && player.extra_linkurious_links.length > 0)" ref="explore-data_item" :class="{'active': activeSection == 'explore-data_item'}">
                  <button  class="text-center" @click="showSection(`explore-data`)"><IconData class="mr-1"  :width="24" :height="24" /></button>
                </li>
                <li v-if="player.documents.length >0" ref="documents_item" :class="{'active': activeSection == 'documents_item'}" >
                  <button  class="text-center" @click="showSection(`documents`)"><IconDocumentText class="mr-1"  :width="24" :height="24" /></button>
                </li>
                <li v-if="player.articles.length > 0" ref="related-stories_item" :class="{'active': activeSection == 'related-stories_item'}">
                  <button  class="text-center" @click="showSection(`related-stories`)"><IconLink class="mr-1"  :width="24" :height="24" /></button></li>
              </ul>

              <BButton class="d-block d-md-none mb-3" variant="dark" @click="showPlayers()">
                <IconVerticalDots />
              </BButton>

              <AboutLinks />
            </div>
          </div>
        </div>
        <div class="col-10 col-sm-10 col-md-7 col-lg-7 bg-content pt-3 pb-3">
          <div class="player_bio__content">
            <div ref="player-bio" class="container_section" data-link="player-bio_item">
              <PlayerMultiHeader :player="player" />
              <div class="row justify-content-center">
                <div class="col-12">
                  <BNav tabs>
                    <BNavItem active><h3><IconBio class="mr-1" /> {{ $t('playerProfile.about') }}</h3></BNavItem>
                    <BNavItem-dropdown v-if="career" right id="dropdown-career" class="d-flex align-self-center">
                      <template #button-content>
                        <span class="text-wrap"><IconDetails class="mr-1" /> {{ $t('playerProfile.career') }}</span>
                      </template>
                      <b-dropdown-text class="p-1">
                        <ul class="p-0">
                          <li :key="c" v-for="c in career">
                            {{ c }}</li>
                        </ul>
                      </b-dropdown-text>
                    </BNavItem-dropdown>
                  </BNav>
                </div>

                <div class="col-12">
                  <div class="m-3"><span v-html="player.bio_intro"></span></div>
                  <BCollapse :visible="moreContentActive" class="m-3" id="collapse-1">
                    <div><span v-html="player.bio_long"></span></div>
                  </BCollapse>
                  <div class="m-3 text-center border-top" v-if="player.bio_long">
                    <b-button @click="moreContent()" variant="light">
                      <div v-if="!moreContentActive">{{ $t('playerProfile.more_bio') }} <IconMore  class="mr-1" /></div>
                      <div v-if="moreContentActive">{{ $t('playerProfile.close_bio') }} <IconLess  class="mr-1" /></div>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div ref="pandora-reveals" class="container_section mt-3" data-link="pandora-reveals_item">
            <div class="row justify-content-center">
              <div class="col-12">
                <BNav tabs>
                  <BNavItem active><h3><IconPandora class="mr-1" /> {{ $t('playerProfile.pandora') }}</h3></BNavItem>
                  <BNavItem-dropdown right id="dropdown-career">
                    <template #button-content>
                      <span class="text-wrap"><IconCountry :height="16" :width="16" /> {{ $t('playerProfile.jurisdiction') }} </span>
                    </template>
                    <b-dropdown-text class="p-1">
                      <ul class="p-0">
                        <li :key="c" v-for="c in secrecy_jurisdictions">
                          {{ translateIsoCountry(c) }}</li>
                      </ul>
                    </b-dropdown-text>
                  </BNavItem-dropdown>
                </BNav>
              </div>
              <div class="col-12">
                <div class="player__bio p-3">
                  <div v-html="player.narrative">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="player.provider && providers.length > 0" ref="secrecy-brokers" class="container_section mt-3" data-link="secrecy-brokers_item">
            <div class="row justify-content-center">
              <div class="col-12">
                <BNav tabs>
                  <BNavItem active>
                    <h3>
                      <IconSecrecy class="mr-1" /> {{ $t('playerProfile.secrecy') }}
                    </h3>
                  </BNavItem>
                </BNav>
              </div>
              <div class="col-12">
                <div v-if="player.provider" class="p-3">
                  <p>{{ $t('playerProfile.secrecy_description') }}</p>
                  <RouterLink class="m-2 btn btn-dark provider-link" :key="c" v-for="c in providers" :to="{ name: 'provider.page', params: { provider_id: kebabCase(c) } }">
                    {{ c }}
                  </RouterLink>

                </div>
              </div>
            </div>
          </div>

          <div v-if="player.linkurious && !player.extra_linkurious_links" ref="explore-data" class="container_section mt-3" data-link="explore-data_item">
            <div class="row justify-content-center">
              <div class="col-12">
                <BNav tabs>
                  <BNavItem active><h3><IconData class="mr-1" /> {{ $t('playerProfile.data') }}</h3></BNavItem>
                </BNav>
              </div>
            </div>

            <div class="row mt-3 justify-content-center">
              <div class="col-12">
                <p class="p-3">{{ $t('playerProfile.data_desc') }}</p>
              </div>
              <div class="col-12">
                <iframe webkitallowfullscreen="" width="100%" height="620px" mozallowfullscreen="" allowfullscreen="" :src="player.linkurious" frameborder="0"></iframe>
              </div>
            </div>
          </div>

          <div v-if="player.extra_linkurious_links && player.extra_linkurious_links.length > 0" ref="explore-data" class="container_section mt-3" data-link="explore-data_item">
            <div class="row justify-content-center">
              <div class="col-12">
                <BNav tabs>
                  <BNavItem active><h3><IconData class="mr-1" /> {{ $t('playerProfile.data') }}</h3></BNavItem>
                </BNav>
              </div>
            </div>

            <div class="row mt-3 justify-content-center">
              <div class="col-12">
                <p class="p-3">{{ $t('playerProfile.data_desc') }}</p>
              </div>
              <div class="col-12">
                <b-tabs card>
                  <b-tab :key="link.widget_url" :title="link.name" v-for="link in player.extra_linkurious_links">
                    <iframe webkitallowfullscreen="" width="100%" height="620px" mozallowfullscreen="" allowfullscreen="" :src="link.link" frameborder="0"></iframe>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>

          <div v-if="player.documents.length >0" ref="documents" class="container_section pt-5 pb-5" data-link="documents_item">
            <div class="row">
              <div class="col-12 mb-3">
                <BNav tabs>
                  <BNavItem active><h3>{{ $t('playerProfile.documents') }}</h3></BNavItem>
                </BNav>
              </div>
              <div class="col-6 col-md-3 related_link" v-for="document in player.documents" :key="document.document_link">
                <div class="related_link__title">
                  <a :href="document.document_link" target="_blank"><IconDocumentText /> {{ document.document_name }}</a>
                </div>
              </div>
              
            </div>
          </div>
          
          <div v-if="player.articles.length > 0" ref="related-stories" class="container_section pt-5 pb-5" data-link="related-stories_item">

            <div class="row justify-content-center mt-5">
              <div class="col-12 mb-3">
                <BNav tabs>
                  <BNavItem active><h3><IconLink class="mr-1" :width="16" :height="16" /> {{ $t('playerProfile.related') }}</h3></BNavItem>
                </BNav>
              </div>
              <div class="col-12">
                <div class="m-2 row previous-coverage">
                  <div class="col-12 col-md-6 related_link" v-for="article in player.articles" :key="article.url">
                    <div class="related_link__title">
                      <a :href="article.url" target="_blank"><IconLink /> {{ article.title }}</a>
                    </div>
                    <div class="related_link__outlet"><span>{{ article.media_outlet }}</span></div>
                    <div class="related_link__date"><span>{{ article.date }}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-block d-md-none">
            <AboutLinks />
          </div>

          <div v-if="!player.note">
            <strong v-html="$t('playerProfile.dateline')"></strong>
          </div>

          <div v-if="player.note">
            <strong v-html="player.note"></strong>
          </div>
        </div>
        
        <div class="d-none col-md-2 col-lg-2 d-md-block" v-if="player">          
          <div class="players-nav text-nowrap">
            <div class="subnav" v-if="player">
              <RouterLink class="subnav-link text-right" :to="{ name: 'home'}" v-if="!isEmbedded">
                {{ $t('playerProfile.all_players') }}
                <IconGrid />
              </RouterLink>
              <BButton variant="primary" class="subnav-link-red border-none w-100" @click="showPlayers()">
                <span class="d-inline text-wrap small">{{ $t('playerProfile.more_region') }} {{ translateRegion(player.region_id) }}
                </span><IconVerticalDots />
              </BButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PlayersRegion :players="regionPlayers.players" :player="player" />

    <div class="players_general_more">
      <MorePlayers :player="player" :region="regionPlayers" />
    </div>

  </div>
</template>

<script>
  import { kebabCase } from 'lodash'
  import IframeResizer from '@icij/murmur/lib/utils/iframe-resizer'
  import AboutLinks from '@/components/AboutLinks.vue'
  import PlayerMultiHeader from '@/components/PlayerMultiHeader'
  import PlayerMapHeader from '@/components/PlayerMapHeader'
  import MorePlayers from '@/components/MorePlayers'
  import IconData from '@/components/IconData'
  import IconSecrecy from '@/components/IconSecrecy'
  import IconLink from '@/components/IconLink'
  import IconDocumentText from '@/components/IconDocumentText'
  import IconPandora from '@/components/IconPandora'
  import IconBio from '@/components/IconBio'
  import IconMore from '@/components/IconMore'
  import IconLess from '@/components/IconLess'
  import IconCountry from '@/components/IconCountry'
  import IconDetails from '@/components/IconDetails'
  import PlayersRegion from '@/components/PlayersRegion'
  import IconGrid from '@/components/IconGrid'
  import IconVerticalDots from '@/components/IconVerticalDots'
  import CustomSharingOptions from '@/components/CustomSharingOptions.vue'

  import playerMixins from '@/mixins/player'
  import utils from '@/mixins/utils'

  export default {
    name: 'Profile',
    mixins: [playerMixins, utils],
    components: {
      AboutLinks,
      IconDetails,
      IconData,
      IconPandora,
      IconSecrecy,
      IconBio,
      IconLink,
      IconDocumentText,
      IconMore,
      IconLess,
      IconCountry,
      PlayerMapHeader,
      PlayerMultiHeader,
      MorePlayers,
      IconGrid,
      IconVerticalDots,
      PlayersRegion,
      CustomSharingOptions
    },
    data () {
      return {
        showMiniProfile: false,
        showSharing: false,
        activeSection: 'player-bio_item',
        moreContentActive: false,
        showShareOptions: false
      }
    },
    mounted () {
      this.bindScroll()
    },
    beforeDestroy () {
      this.unbindScroll()
    },
    computed: {
      isEmbedded () {
        return IframeResizer.isEmbedded()
      }
    },
    methods: {
      kebabCase,
      moreContent(){
        this.moreContentActive = !this.moreContentActive
      },
      async showSection(section) {
        this.activeSection = `${section}_item`
        const { top } = this.$refs[section].getBoundingClientRect()
        if (this.isEmbedded) {
          const pymChild = await IframeResizer.create().initializer
          pymChild.scrollParentToChildPos(top)
        } else {
          const behavior = 'smooth'
          window.scrollTo({ top, behavior })
        }
      },
      async bindScroll () {
        if (this.isEmbedded) {
          const pymChild = await IframeResizer.create().initializer
          pymChild.onMessage('viewport-iframe-position', this.onIframeScroll);
        } else {
          window.addEventListener('scroll', this.onScroll)
        }
      },
      unbindScroll () {
        window.removeEventListener('scroll', this.onScroll)
      },
      onIframeScroll (parentInfo) {
        const playerBlock = this.$el.querySelector('.player_general_info')
        const navigationBlock = this.$el.querySelector('.side_navigation')
        const viewportHeight = parseInt(parentInfo.split(' ')[1])
        const iframeTop  = parseInt(parentInfo.split(' ')[2])
        const iframeTopAbs = Math.abs(Math.min(0, iframeTop))
        const navigationMaxTop = playerBlock.offsetHeight - navigationBlock.offsetHeight
        const navigationTop = Math.min(navigationMaxTop, Math.max(0, iframeTopAbs - playerBlock.offsetTop))
        this.$el.style.setProperty('--navigation-top', `${navigationTop}px`)
        this.updateNavigation(iframeTopAbs, viewportHeight)
      },
      onScroll () {
        this.updateNavigation(window.scrollY)
      },
      updateNavigation (scrollY, viewportHeight = window.innerHeight) {
        const triggers = document.querySelectorAll('.container_section')
        const bigCard = document.querySelector('.player-card-big')
        this.showMiniProfile = scrollY >= (bigCard.offsetTop + bigCard.offsetHeight)
        Array.from(triggers).forEach(t => {
          const { height, top } = t.getBoundingClientRect()
          const start = top - (viewportHeight * 0.4)
          const end = top + height - 450
          const active = scrollY >= start && scrollY <= end
          this.activeSection = active ? t.dataset.link : this.activeSection
        })
      },
      hidePlayers () {
        document.getElementById('container-more-players').classList.remove('open-nav')
        document.querySelector('body').classList.remove('open-nav')
      },
      showPlayers  () {
        document.getElementById('container-more-players').classList.add('open-nav')
        document.querySelector('body').classList.add('open-nav')
      },
      toggleSharing () {
        this.showSharing = !this.showSharing
      }
    }
  }
</script>

<style lang="scss" scoped>

  @mixin animation-delay-loop($from:0, $to:10, $delay: 300ms) {
    @for $i from $from through $to {
        &:nth-child(#{$i}) {
          animation-delay: $i * $delay;
        }
    }
  }

  @keyframes slideDown {
    from {
      opacity: 1;
      top: 0;
    }
    to {
      opacity: 0;
      top: 150px;
    }
  }


  @keyframes slideShareBtn {
    from {
      opacity: 0;
      transform: translateY(-100%);
    }
    to {
      opacity: 1;
      transform: translateY(0%);
    }
  }


  @keyframes slideLeft {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
  }

  @keyframes slideMenu {
    from {
        opacity: 0;
        transform: translateX(15px);
    }
    to {
        opacity: 1;
        transform: translateX(15px);
    }
  }

  .nav-item .nav-link {
    font-size: 16px;

    h3 {
      margin: 0;
      font-size: 16px;
      color: var(--app-color-red);
    }
  }

  .side_navigation {
    position: sticky;
    top: 0;

    .embedded & {
      position: absolute;
      top: 0;      
      transform: translateY(var(--navigation-top, 0));
      transition: transform 0.3s;
      padding-top: 3rem;
    }
  }

  .players-nav {
    position: sticky;
    top: 85px;
    
    .embedded & {
      position: absolute;
      top: 0;
      transform: translateY(var(--navigation-top, 0));
      transition: transform 0.3s;
    }

    @media (max-width: 767.98px) {
      right: -350px;
    }

    .card-img-side {
      display: block;
      width: auto;
      height: 55px;
      margin-right: 10px;
      float: left;
      border-radius: 100%;
      background: var(--app-color-black);
    }

    .subnav-link-red {
      border-radius: 0 !important;
      text-align: right;
    }

    .subnav-link {
      display: block;
      width: 100%;
      padding: 10px 10px;
      margin-bottom: 5px;
      color: #fff !important;
      background: var(--app-color-black);
      border: none;
      border-right: solid 1px var(--app-color-white);
      font-size: 14px;
      border-radius: 0 !important;
    }
  }

  .profile_top {
    position: relative;
    width: 100%;
    max-width: 320px;
    top: 0;
    margin-bottom: 1.5rem;
    left: 0;
    padding: 5px 15px;
    align-items: flex-end;
    transition: opacity .2s ease-in-out;
    pointer-events: all;
    opacity: 0;

    &.active {
      opacity: 1;
    }

    &__share-btn {
      border:1px solid transparent;
      padding: 0;
      height: 1.5rem;
      line-height: 1.5rem;
      width: 1.5rem;
      font-size: .8rem;
      text-align: left !important;
      border-radius: 50%;
      margin-left: 0.5rem;
      background: var(--app-color-black);      

      &.active {
        border-color: white;
      }
      &:hover {
        background: var(--app-color-red);
      }
    }

    & /deep/ .sharing-options {
      position: absolute;
      left: 100%;
      top: 0;
      padding-left: .25rem;

      &__link {
        margin-top: 0;
        height: 1.5rem;
        line-height: 1.5rem;
        width: 1.5rem;
        font-size: .8rem;
        opacity: 0;
        animation: slideShareBtn 200ms forwards;
        @include animation-delay-loop(0, 10, 50ms);
      }
    }

    img {
      width: 100%;
      background: var(--app-color-coin);
      border-radius: 100%;
    }

    h4 {
        font-size: 17px;
    }

    h5 {
      font-size: 15px;
      color: var(--app-color-red);
    }

    h6 {
      font-size: 14px;
      color: var(--app-color-red);
    }
  }

  .related_link {
    padding: 15px;
    border-bottom: solid 1px var(--app-color-light);

    a {
      color: var(--app-color-black);
    }

    &__title {
      font-size: 17px;
      font-weight: 600;
    }

    &__outlet {
      font-size: 16px;
      color: var(--app-color-red);
    }

    &__date {
      font-size: 13px;
    }
  }

  .career_list {
    color: #fff;
    background:  var(--app-color-dark);

    ul {
      margin: 0;

      li {
        font-size: 16px;
        margin-bottom: 5px;
      }
    }
  }

  .previous-coverage {
    img {
      width: 100%;
    }
  }

  .player {
    .nav-tabs .nav-link{
      min-width: 120px;
      background-color: transparent !important;
    }

    .nav-tabs .nav-item{
      min-width: 120px;
      background-color: transparent !important;
    }

    .nav-tabs {
      border-bottom: 1px solid #dee2e6;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }

    .provider-link {
      font-size: 18px;
    }

    .scrollDown {
      position: relative;
      width: 160px;
      margin: 55px auto;
      font-weight: 600;
      animation: slideDown 1.8s infinite;
      color: var(--app-color-dark-green);
    }

    .hide-section-button {
      position: fixed;
      bottom: 15px;
      right: 15px;

      button {
        width: 48px !important;
        height: 48px !important;
        padding: 6px !important;
        border-radius: 100% !important;
      }

      svg {
        width: 32px !important;
        height: 32px !important;
      }
    }

    .profile-navigation-container {
      @media (max-width: 767.98px) {
        &.active {
          .hide_section {
            width: 100;
            left: 15px;
          }

          .subnav {
            right: 0 !important;
          }
        }
      }
    }

    .hide_section {
      position: sticky;
      top: 0;
      z-index: 100;
      width: 100%;
      max-width: 250px;
      pointer-events: none;
      animation: slideMenu 1.2s forwards 1 ease-in-out;
    }

    .side_navigation {
      h2 {
        margin-bottom: 15px;
        padding: 5px;
        font-size: 18px;
        color: var(--app-color-red);
      }

      ul {
        margin: 0;
        padding: 0;
      }

      li {
        display: block;
        width: 100%;
        margin-bottom: 10px;
        background-color: var(--app-color-black);
        border-radius: 5px;

        button {
          text-align: left;
          font-weight: 900px;
        }


        &.active {
          text-align: right;
          background-color: var(--app-color-red);
        }

        &:hover {
          background-color: var(--app-color-red);
        }

        button {
          width: 100%;
          display: block;
          padding: 10px;
          color: white;
          border: none;
          background: transparent;
        }
      }

      button {
        pointer-events: all;
      }
    }

    .player_general_info {
      z-index: 100;
      position: relative;
      max-width: 1220px;
      margin: #{"min(20vh, 250px)"} auto 65px auto;
      padding: 15px;
      animation: slideLeft 1.2s forwards 1 ease-in-out;

      .bg-content {
        background: #ffffffeb;
      }
    }

    .map_leak {
      max-width: 920px;
      margin: 0 auto;
    }

    .player_trigger {
      min-height: 200vh;
    }

    .map-sticky {
      position: fixed;
      top: 0;
      width: 100%;
      height: 100vh;
      z-index: 0;
    }

    &__nav_profile {
      position: sticky;
      top: 55px;
      z-index: 1020;
      min-height: 55px;
      padding: 15px;
      color: var(--app-body-bg);
      background-color: var(--app-color-coin);
      align-items: center;
      transition: opacity .25s ease-in;

      &.active {
        opacity: 1;
      }

      &.reveal {
        background-color: var(--app-color-orange);
      }

      ul {
        max-width: 720px;
      }

      a.client_name {
        font-size: 21px;
        color: #ffffff;
        text-decoration: none;
        background-color: transparent;
      }

      a.role {
        font-size: 16px;
        color: var(--app-color-light);
        text-decoration: none;
        background-color: transparent;
      }
    }
  }

  .img-nav {
    max-width: 55px;
    margin-right: 15px;
    border-radius: 55px;
  }

</style>
